import { GzDetonationProfileWebComponent } from './component/GzDetonationProfileWebComponent';

export { GzDetonationProfileWebComponent };
